export default "__VITE_ASSET__BENA3$UY__"